import { MAX_LIMIT } from 'config';
import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';

import { EntityTypes } from 'context/entityContext';
import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';

export default getRadioTrendUrl;

export interface IRadioTrendUrlArgs {
  entityType: EntityTypes;
  entityIds: string[];
  countryIds?: string[];
  download?: boolean;
  period?: string;
  breakdown?: string;
  region?: string;
  compareMode?: string;
  customRegion?: string | string[];
}

function getRadioTrendUrl(args: IRadioTrendUrlArgs): string {
  const {
    entityType,
    entityIds,
    countryIds,
    download,
    period,
    breakdown,
    region,
    compareMode,
    customRegion,
  } = args;

  const type = entityTypeToApiType(entityType);
  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    download,
    period,
    breakdown,
    limit: period === 'year' ? MAX_LIMIT : undefined,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
  });

  return `/api/radio/trend/${type}/${entityIds}?${params}`;
}
